<div class="card-title-block-non-sticky" *ngIf="isDocumentNotFound && !isLoading">
	<copo-back-button></copo-back-button>
	<span class="card-title-label" translate>document-card.data-not-found</span>
</div>
<div class="sidenav-content" [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" *ngIf="!(isDocumentNotFound && !isLoading)">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="certificateData && certificateDisplayed">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<span class="card-title-label" translate>commercial-documents.certificate-card</span>
					<span class="card-title-label card-title-name-label">{{certificateData.name ? certificateData.name : UNDERSCORE}}</span>
					<a mat-icon-button class="order-card-document-link-block"
						[href]="getDocumentURL(certificateData.id,certificateData.name) | copoSafeUrl" target="_blank"
						type="application/pdf" (click)="scroller.saveState()" [title]="'quapp.action.view' | translate">
						<mat-icon color="accent" svgIcon="md:eye"></mat-icon>
					</a>
					<a mat-icon-button class="order-card-document-link-block"
						[href]="getDownloadDocumentUrl(certificateData.id,certificateData.name) | copoSafeUrl" target="_blank"
						type="application/pdf" (click)="scroller.saveState(); trackDownload(certificateData.id)" [title]="'sb.Download' | translate">
						<mat-icon color="accent" svgIcon="md:download"></mat-icon>
					</a>
				</div>
				<div class="copo-container footer-margin" copoAfterViewInit (afterviewinit)="scroller.restoreState()">
					<div class="grid-6">
						<div class="grid-column-one-full">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title class="card-content-title">
										<span translate>commercial-documents.general-information</span>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<mat-icon class="row-icon certificate-info-label" svgIcon="at_consignment"></mat-icon>
										<span class="card-content-value">
											{{certificateData.millDescription ? certificateData.millDescription : UNDERSCORE}}
										</span>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.customer</div>
										<div class="card-content-value">{{certificateData.soldtoName ? certificateData.soldtoName : UNDERSCORE}} </div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.certificate-date</div>
										<div class="card-content-value">{{(certificateData.date ? certificateData.date : UNDERSCORE) | copoDate:'date' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.shipto</div>
										<div class="card-content-value">{{certificateData.shiptoName ? certificateData.shiptoName : UNDERSCORE}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.type</div>
										<div class="card-content-value">{{certificateData.subtypeDescription ? certificateData.subtypeDescription : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.payer</div>
										<div class="card-content-value">{{certificateData.payerName ? certificateData.payerName : UNDERSCORE}}</div>
									</div>
								</div>
							</div>
							</mat-expansion-panel>
						</div>
					</div>
					<div class="grid-column-one-full document-card-batch-order-details card-title-name-label" translate>commercial-documents.batches-details</div>
					<div class="document-card-orders-details-headers">
						<span translate>commercial-documents.heat-number
							<span>(&nbsp;{{heatNumbers.length}}&nbsp;)</span>
						</span>
						<button type="button" translate class="tag-order-number tag-order-number-clickable batch-details-margin-left"
							[ngClass]="{'active-tag-order-number active-tag-order-number-clickable': allBatchesDisplayed }"
							(click)="allBatchesDisplayed = true; displayAllBatches()">datacenter.all
						</button>
						<span *ngFor="let heatNumber of heatNumbers" class="batch-details-margin-left">
							<button type="button" class="tag-order-number tag-order-number-clickable"
								[ngClass]="{'active-tag-order-number active-tag-order-number-clickable': !allBatchesDisplayed && heatNumber.isSelected}"
								(click)="filterBatch(heatNumber)">
								{{heatNumber.key ? heatNumber.key : 'commercial-documents.emptyHeatNumber' | translate}}
							</button>
						</span>
					</div>
					<div *ngFor="let certificate of certificateData.documentLines">
						<div *ngIf="certificate.isSelected" class="document-card-margin-bottom">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title>
										<div class="batch-details-card-first-row">
											<span class="card-sub-title" translate>shipment.filter.batch-number</span>
											<span class="card-sub-title">{{certificate.batchNumber ? certificate.batchNumber : UNDERSCORE}}</span>
											<span class="tag-order-number tag-order-number-not-active">{{ getOrderNumber(certificate) }}</span>
										</div>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
							
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.ce.enduser</div>
										<div class="card-content-value">{{certificate.enduserName ? certificate.enduserName : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.mill-order-number</div>
										<div class="card-content-value">{{getMillOrderNumber(certificate)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.weight </div>
										<div class="card-content-value">{{getQtyBatch(certificate.batchNumber, 'WEIGHT')}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents-da.heat</div>
										<div class="card-content-value">{{certificate.heatNumber ? certificate.heatNumber : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate> commercial-documents.product</div>
										<div class="card-content-value">{{certificate.productDescription ? certificate.productDescription : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.dispatch-advice-number</div>
										<div class="card-content-value">{{certificate.dispatchAdviceNumber ? certificate.dispatchAdviceNumber : UNDERSCORE}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate> commercial-documents.ce.serial-number</div>
										<div class="card-content-value">{{(certificate.packageSerialNumber ? certificate.packageSerialNumber : UNDERSCORE) }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate> commercial-documents.ce.supplier-article-reference </div>
										<div class="card-content-value">{{certificate.supplierArticleReference ? certificate.supplierArticleReference : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate> shipment.dispatch-advice-date </div>
										<div class="card-content-value">{{(certificate.dispatchAdviceDate ? certificate.dispatchAdviceDate : UNDERSCORE) | copoDate:'date'}}</div>
									</div>
								</div>
							</div>
							</mat-expansion-panel>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>